import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetInsert87TwoFullCaption() {
    return (<FullCaptionComponent title="VALUE: 87">
        <HashSetInsert87Two1/>
    </FullCaptionComponent>)
}

export function HashSetInsert87Two1() {
    return (
        <CaptionStepComponent title={<h6>1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
            unique. <CodeComponent>O(1)</CodeComponent></h6>}>
            <p>Here, we see we are trying to add a <CodeComponent className="codeValue">VALUE</CodeComponent> of 87 that
                is already in the HashSet. As this is not a <i>unique</i> element, we do not move to steps 2-5.</p>
        </CaptionStepComponent>)
}
